<template minapp='mpx' xlang='wxml'>
  <from-item isShow="{{isShow}}" 
    isRequiredShow="{{isRequiredShow}}" 
    label="邮箱地址" 
    innerValue="{{innerValue}}"
    nameTips="{{nameTips}}"
  > 
    <es-field class="es-field-email" placeholder="用于接受12306的邮件，选填" wx:model="{{innerValue}}" bindblur="onBlur" slot="input"/>
  </from-item>
</template>

<script>
  import { watch } from "@mpxjs/core";
  import { createComponent } from '@didi/es-mpx-creator'
  import { hasRequired ,permitValidateConf} from '@/utils'
  import Validator from '@/utils/validator'
  createComponent({
    classes: [],
    data: {
      innerValue:'',
      nameTips:''
    },
    props: {
      value:{
        type: String,
        value: ''
      },
      isShow:{
        type: Boolean,
        value: true
      },
      item:Object,
      selectedCardList:Array,
      isNeedCard:Boolean,
      isRequiredShow: {
        type: Boolean,
        value: false
      },
    },
    computed: {
    },
    methods: {
      onBlur(e){
        if (!this.innerValue) return 
        var validator = new Validator()
        validator.cbAdd(this.innerValue, this.item.validator, this.item.tips)
        this.nameTips = validator.start()
        // this.$trigger( 'blur', {value: e.detail.value, origin:'email'} )
      }
    },
    watch:{
      value(val) {
        this.innerValue = val
      },
      //将数据回传
      innerValue(newValue) {
        this.$trigger( 'input', {value:newValue} )
      },
    }
  })
</script>

<style lang='stylus' scoped>
.es-field-email
    /deep/ .es-field__inner
      width: auto;
</style>

<script name='json'>
  module.exports = {
    component: true,
    "usingComponents": {
      'es-cell': '@didi/es-mpx-ui/lib/cell',
      'es-field': '@didi/es-mpx-ui/lib/field',
      'from-item': './from-item'
    }
  }
</script>

